import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Inteligencia from './pages/Inteligencia';
import Generacion from './pages/Generacion';
import Historial from './pages/Historial';
import Guias     from './pages/Guias';
import Leads     from './pages/Leads';
import Comunidad from './pages/Comunidad';
import Perfil    from './pages/Perfil';

function ProtectedRoute() {
  const { token } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  return <Outlet />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="inteligencia" element={<Inteligencia />} />
              <Route path="generacion" element={<Generacion />} />
              <Route path="historial" element={<Historial />} />
              <Route path="guias"     element={<Guias />} />
              <Route path="leads"     element={<Leads />} />
              <Route path="comunidad" element={<Comunidad />} />
              <Route path="perfil"    element={<Perfil />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
